<script>

export default {
  name: 'LegalDocument',

  props: {
    legalDocument: {
      type: Object,
      required: true
    }
  },

  computed: {
    title () {
      let kind = this.legalDocument.kind
      if (kind == "fueling_conditions" && this.isBikeOnly) {
        kind = "fueling_conditions_bike"
      }
      return this.$t(`legal_documents.kinds.${kind}`)
    }
  }
}
</script>

<template>
  <div class="legal-document">
    <a :href="legalDocument.url" target="_blank">
      <span class="icon">
        <svg-icon name="icon_document" size="50" :fill="teamsiteConfig.color"></svg-icon>
      </span>
      <span class="text" v-html="title"></span>
    </a>
  </div>
</template>

<style lang="scss" scoped>
.legal-document {
  font-size: rem-calc(25);

  @include breakpoint(medium down) {
    font-size: rem-calc(20);
    margin-bottom: rem-calc(30);
  }

  a {
    display: table;
    text-align: left;
    line-height: 1.2em;
    color: black;
    text-decoration: none;
    width: 100%;
    min-height: rem-calc(75);

    &:hover {
      text-decoration: underline;
    }

    .text, .icon {
      display: table-cell;
      vertical-align: middle;
    }

    .icon {
      width: rem-calc(50);
      line-height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LegalDocument.vue